import React, { useState } from "react";
import Replicate_Testing_Filter from "./replicate_testing_filter/Replicate_Testing_Filter";
import Common_Report_Offcanvas from "../../../../common_report_offcanvas/Common_Report_Offcanvas";
import Replicate_Testing_Table from "./replicate_testing_table/Replicate_Testing_Table";
import { GetNonConformingReport } from "../../../../../../../features/admin/report_generator/Slice";
import { useDispatch, useSelector } from "react-redux";
import { FixIDS } from "../../../../../../../utils/fixIDS";

const Replicate_Testing = ({
  setSearchParams,
  reportgenerate,
  validitydetails,
  setCurrentPage,
  currentPage,
}) => {
  const [show, setShow] = useState(false);

  const permissions = useSelector((state) => state.auth.permissions);
  const haveReportPermission = permissions?.includes(
    FixIDS.replicate_testing_report.Report,
  );

  return (
    <section className="Sample_Report">
      <div className="Sample_Report_Filter_div">
        <Replicate_Testing_Filter
          setShow={setShow}
          reportgenerate={reportgenerate}
          setSearchParams={setSearchParams}
        />
      </div>

      <div className="report_table_div">
        {haveReportPermission && (
          <Replicate_Testing_Table
            validitydetails={validitydetails}
            setCurrentPage={setCurrentPage}
            currentPage={currentPage}
          />
        )}
      </div>
    </section>
  );
};

export default Replicate_Testing;
